/**
 * Сравнение двух итогов партии по месту: меньше нуля — `a` выше `b`. Порядок
 * при равенстве finalWinPoints — тай-брейки по убыванию приоритета: доход
 * (очки + монеты/2) -> великие руины -> руины -> великие рудники -> рудники.
 * Ноль — полная ничья: все критерии равны, и игроки делят место. Отсутствующий
 * критерий считается нулем (в итогах без тай-брейк-полей решают только очки)
 */
export function compareGameResults(a, b) {
  return (
    (b.finalWinPoints ?? 0) - (a.finalWinPoints ?? 0)
    || (b.income ?? 0) - (a.income ?? 0)
    || (b.superRuinsCount ?? 0) - (a.superRuinsCount ?? 0)
    || (b.ruinsCount ?? 0) - (a.ruinsCount ?? 0)
    || (b.superMinesCount ?? 0) - (a.superMinesCount ?? 0)
    || (b.minesCount ?? 0) - (a.minesCount ?? 0)
  );
}

/**
 * Реальные места (с 1) для итогов, уже отсортированных по compareGameResults.
 * Полностью равные игроки делят лучшее место группы, а следующий за ними
 * получает место с учетом всех, кто его опередил: 1, 2, 2, 4 (а не 1, 2, 2, 3)
 */
export function getGameResultsPlaces(sortedResults) {
  const places = [];
  sortedResults.forEach((result, index) => {
    const isTiedWithPrevious = index > 0 && compareGameResults(sortedResults[index - 1], result) === 0;
    places.push(isTiedWithPrevious ? places[index - 1] : index + 1);
  });
  return places;
}

/**
 * Наградные места (с 1) для итогов, отсортированных по compareGameResults.
 * Награда зависит от того, скольких игроков реально обыграл участник, поэтому
 * при полной ничьей все ее участники получают худшее место группы: двое на
 * 1-2 местах — награду за 2-е, шестеро в ничьей — за 6-е. Одиночные места
 * совпадают с обычными: 1, 2, 3 ...
 */
export function getGameResultsRewardPlaces(sortedResults) {
  const rewardPlaces = new Array(sortedResults.length);
  let groupStart = 0;
  while (groupStart < sortedResults.length) {
    let groupEnd = groupStart;
    while (
      groupEnd + 1 < sortedResults.length
      && compareGameResults(sortedResults[groupEnd], sortedResults[groupEnd + 1]) === 0
    ) {
      groupEnd += 1;
    }
    for (let i = groupStart; i <= groupEnd; i += 1) {
      rewardPlaces[i] = groupEnd + 1;
    }
    groupStart = groupEnd + 1;
  }
  return rewardPlaces;
}
